import { Eye, LogOut } from "lucide-react";

/**
 * Fixed banner at the top of every page inside an impersonation tab.
 * Returns null if this tab is not in impersonation mode.
 */
export default function ImpersonationBanner() {
  let imp = false;
  let email = "";
  try {
    imp = sessionStorage.getItem("impersonating") === "1";
    email = sessionStorage.getItem("imp_email") || "";
  } catch { /* ignore */ }
  if (!imp) return null;

  const exit = () => {
    try {
      sessionStorage.removeItem("impersonating");
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("refresh_token");
      sessionStorage.removeItem("imp_email");
      sessionStorage.removeItem("imp_name");
    } catch { /* ignore */ }
    // Close the tab (opener) or redirect to login
    try { window.close(); } catch { /* ignore */ }
    window.location.replace("/login");
  };

  return (
    <div className="sticky top-0 z-[200] w-full bg-[#F59E0B] text-[#0B0E14] px-4 py-2 flex items-center justify-between gap-3 shadow-md" data-testid="impersonation-banner">
      <div className="flex items-center gap-2 min-w-0">
        <Eye className="w-4 h-4 flex-shrink-0" />
        <span className="text-xs sm:text-sm font-bold truncate">
          Viewing as <span className="underline">{email || "user"}</span> · Admin impersonation session (auto-expires in 1h)
        </span>
      </div>
      <button onClick={exit} data-testid="exit-impersonation-btn"
        className="flex items-center gap-1 px-3 py-1 text-[11px] font-bold uppercase tracking-widest bg-[#0B0E14] text-[#F59E0B] rounded hover:bg-[#131722] transition-colors flex-shrink-0">
        <LogOut className="w-3 h-3" /> Exit
      </button>
    </div>
  );
}
